import { createTheme } from '@mui/material';
import defaultTheme from 'tailwindcss/defaultTheme';
import {
  iotsBrandColors,
  iotsColors,
  iotsBoxShadow,
  iotsLightGrey,
} from './assets/iotsPalette.js';
import '@mui/x-data-grid/themeAugmentation';

const fontFamily = defaultTheme.fontFamily.sans.join(',');

export const createtheme = (rootElement: HTMLElement) =>
  createTheme({
    typography: {
      fontFamily,
    },
    palette: {
      primary: {
        ...iotsColors.emerald,
        main: iotsBrandColors.DEFAULT,
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: iotsBoxShadow as string,
          },
        },
      },
      MuiAutocomplete: {
        defaultProps: {
          size: 'small',
          fullWidth: true,
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily,
            lineHeight: '20px',
            fontSize: '14px',
            textTransform: 'none',
            padding: '8px 16px',
            '&.Mui-disabled': {
              backgroundColor: iotsLightGrey as string,
            },
          },
          sizeSmall: {
            padding: '6px 10px',
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: 0,
          },
          columnHeader: {
            backgroundColor: iotsBrandColors.DEFAULT,
            color: iotsBrandColors.inverted,
            '&:focus': {
              outline: 0,
            },
            '& .MuiSvgIcon-root': {
              color: iotsBrandColors.inverted,
            },
          },
        },
      },
      MuiDialog: {
        defaultProps: {
          container: rootElement,
        },
      },
      MuiFormControl: {
        defaultProps: {
          size: 'small',
          fullWidth: true,
        },
      },
      MuiInputBase: {
        defaultProps: { size: 'small', fullWidth: true },
        styleOverrides: {
          input: {
            fontFamily,
            fontSize: '14px',
          },
          root: {
            '&.Mui-disabled': {
              backgroundColor: iotsLightGrey as string,
            },
          },
        },
      },
      MuiModal: {
        defaultProps: {
          container: rootElement,
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              backgroundColor: iotsLightGrey as string,
            },
          },
        },
      },
      MuiPopover: {
        defaultProps: {
          container: rootElement,
        },
      },
      MuiPopper: {
        defaultProps: {
          container: rootElement,
        },
      },
      MuiSelect: {
        defaultProps: {
          size: 'small',
          fullWidth: true,
        },
        styleOverrides: {
          select: {
            fontFamily,
            fontSize: '14px',
          },
          root: {
            '&.Mui-disabled': {
              backgroundColor: iotsLightGrey as string,
            },
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            padding: '8px',
            textTransform: 'none',
            minHeight: 'unset',
            fontWeight: 400,
            lineHeight: '20px',
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          select: {
            width: 'auto',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            minHeight: 'unset',
          },
          indicator: {
            height: '1.6px',
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          fullWidth: true,
        },
      },
      MuiToggleButtonGroup: {
        defaultProps: {
          size: 'small',
          fullWidth: true,
        },
      },
      MuiToggleButton: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              background: iotsBrandColors.DEFAULT,
              color: iotsBrandColors.inverted,
              '&.Mui-disabled': {
                opacity: 0.6,
              },
              '&:not(.Mui-disabled):hover': {
                background: iotsBrandColors.DEFAULT,
                color: iotsBrandColors.inverted,
                opacity: 0.8,
              },
            },
          },
        },
      },
    },
  });
